import { createAuthClient } from "better-auth/react";
import { convexClient, crossDomainClient } from "@convex-dev/better-auth/client/plugins";
import type { ConvexEnv } from "../env";

/**
 * better-auth's routes are mounted on the Convex deployment's HTTP-actions
 * origin (`.convex.site`, see apps/peek-cloud/http.ts and auth.ts), not the
 * `.convex.cloud` origin the reactive client talks to — `baseURL` must point
 * there. `crossDomainClient` mirrors apps/peek-cloud's `crossDomain` server
 * plugin so the Pages app persists the auth cookie in first-party storage and
 * forwards it via Better-Auth-Cookie; that avoids third-party cookie blocking
 * between `peek-web.pages.dev` and the Convex `.site` origin.
 */
export function createPeekAuthClient(env: ConvexEnv) {
  return createAuthClient({
    baseURL: env.convexSiteUrl,
    plugins: [convexClient(), crossDomainClient()],
  });
}

export type PeekAuthClient = ReturnType<typeof createPeekAuthClient>;
